import CommonRenderComponent from '../../../components/common/common-column-components/common-render-component'
import CommonEditComponent, { FormItemPropsInterface } from '../../../components/common/common-column-components/common-edit-component'
import React from 'react'
import moment from 'moment'

// --------------------------------compareTwoObjs-------------------------------------
export const compareTwoObjs = (obj1: any, obj2: any) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2)
}

// --------------------------------columnFunction-------------------------------------
interface ColumnFunctionPropsInterface {
  keywords: any
  isForRender?: boolean
  itemsObj?: any
  props?: any
  restFormItems?: any
}

const columnFunction = (columnFunctionProps: ColumnFunctionPropsInterface) => {
  const formItems: FormItemPropsInterface = columnFunctionProps.keywords.map((keyword: any) => columnFunctionProps.itemsObj[keyword])
    return columnFunctionProps.isForRender ?
    <CommonRenderComponent formItems={formItems} restFormItems={columnFunctionProps.restFormItems} /> :
    <CommonEditComponent propsFunction={columnFunctionProps.props} formItems={formItems} restFormItems={columnFunctionProps.restFormItems} />
}

export const renderFn = (itemsObj: any, keywords: any, restFormItems?: any) => {
  const columnFnProps: any = {isForRender: true, itemsObj: itemsObj, keywords: keywords, restFormItems: restFormItems}
  return columnFunction(columnFnProps)
}

export const editFn = (props: any, itemsObj: any, keywords: any, restFormItems?: any) => {
  const columnFnProps: any = {keywords: keywords, props: props, itemsObj: itemsObj, restFormItems: restFormItems}
  return columnFunction(columnFnProps)
}

export const filterFn = (inputValue: any, itemsObj: any, keywords: any,) => {
  // 安全检查：如果 keywords 为 undefined 或 null，返回 false
  if (!keywords || !Array.isArray(keywords)) {
    console.log('🔍 filterFn - keywords is invalid:', keywords)
    return false
  }

  let result = false
  keywords.map((keyword: any) => {
    if (commonFilterFn(inputValue, itemsObj[keyword].value)) {
      result = true
    }
  })
  return result
}

const escapeRegExp = (s: string): string =>
  s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

// 独立单词匹配 (Option A):
//   - 短 token (长度 <= 2, 如首字母 / Mr / Dr) 走 substring, 允许被更长单词吸收
//   - 长 token (长度 >= 3) 走严格整词, 命中后从 haystack 中挖掉, 防短 token 被吸收
const originalCommonFilterFn = (
  _inputValue: any,
  _dataValue: any
): boolean => {
  const input = String(_inputValue ?? '').toLowerCase().trim()
  const data = String(_dataValue ?? '').toLowerCase()

  if (!input) return true

  const tokens = input
    .split(/\s+/)
    .filter(Boolean)
    .sort((a, b) => b.length - a.length)

  let remaining = data

  for (const token of tokens) {
    if (token.length <= 2) {
      if (!remaining.includes(token)) return false
      continue
    }

    // 长 token: 允许匹配单词开头，因此 eater 可以匹配 eatery
    // const re = new RegExp('(^|\\s)' + escapeRegExp(token), 'i')
    if (!data.includes(token)) return false
    remaining = remaining.replace(token, ' ')
  }

  return true
}

export const commonFilterFn = (
  inputValue: any,
  dataValue: any
): boolean => {
  if (
    inputValue === undefined ||
    inputValue === null ||
    inputValue === ''
  ) {
    return true
  }

  const inputStr = String(inputValue)
  const haystack = String(dataValue ?? '').toLowerCase()

  // 检测 token 是否被引号包裹 (双引号 / 单引号都支持)
  const quoteOf = (t: string): string | null => {
    if (t.length >= 2 && (t.startsWith('"') || t.startsWith("'"))) {
      if (t.endsWith(t[0])) return t[0]
    }
    return null
  }

  // tokenize: 双引号 / 单引号短语 (保留内部空格) 或非空白序列
  //   "kitchen"     -> ["kitchen"]
  //   'kitchen'     -> ['kitchen']
  //   "full phrase" -> ["full phrase"]
  //   k kitchen     -> [k, kitchen]
  const tokens = inputStr.match(/"[^"]*"|'[^']*'|\S+/g) || []

  const hasQuoted = tokens.some((t) => quoteOf(t) !== null)

  // 无引号: 走原始整词匹配
  if (!hasQuoted) {
    return originalCommonFilterFn(inputValue, dataValue)
  }

  // 有引号: 逐 token 匹配
  for (const rawToken of tokens) {
    const q = quoteOf(rawToken)
    if (q !== null) {
      // 引号短语: 字面 substring 匹配 (保留内部空格)
      const phrase = rawToken.slice(1, -1).toLowerCase()
      if (phrase.length === 0) continue
      if (!haystack.includes(phrase)) return false
    } else {
      // 普通 token: 走独立单词匹配
      if (!originalCommonFilterFn(rawToken, dataValue)) return false
    }
  }

  return true
}

export const validateFn = (rowData: any, itemsObj: any, keywords: any) => {
  let result = true
  let errorMessage = ''

  keywords.map((keyword: any) => {
    // 必填验证
    if (itemsObj[keyword].required) {
      if (result) {
        if (itemsObj[keyword].type === 'inputNumber') {
          if (rowData[keyword] < 0) {
            result = false
            const label = itemsObj[keyword].label || keyword
            errorMessage = `${label} cannot be negative`
          } else if (rowData[keyword] === undefined || rowData[keyword] === null || rowData[keyword] === '') {
            result = false
            const label = itemsObj[keyword].label || keyword
            errorMessage = `${label} is required`
          }
        } else if (!rowData[keyword]) {
          result = false
          const label = itemsObj[keyword].label || keyword
          errorMessage = `${label} is required`
        }
      }
    }
    // 最大长度验证
    if (result && itemsObj[keyword].maxLength && rowData[keyword]) {
      if (rowData[keyword].length > itemsObj[keyword].maxLength) {
        result = false
        const label = itemsObj[keyword].label || keyword
        errorMessage = `${label} must be no more than ${itemsObj[keyword].maxLength} characters`
      }
    }
    // 数字范围验证（对于 rating 等字段）
    if (result && itemsObj[keyword].type === 'inputNumber' && rowData[keyword] !== undefined && rowData[keyword] !== null && rowData[keyword] !== '') {
      if (itemsObj[keyword].min !== undefined && rowData[keyword] < itemsObj[keyword].min) {
        result = false
        const label = itemsObj[keyword].label || keyword
        errorMessage = `${label} must be at least ${itemsObj[keyword].min}`
      }
      if (itemsObj[keyword].max !== undefined && rowData[keyword] > itemsObj[keyword].max) {
        result = false
        const label = itemsObj[keyword].label || keyword
        errorMessage = `${label} must be no more than ${itemsObj[keyword].max}`
      }
    }
  })

  return result ? true : { isValid: false, helperText: errorMessage }
}

const getItemObjFunction = (rowData: any, label: string, keyword: any, otherOptions?: any) => {
  let obj: any = {
    label: label,
    keyword: keyword,
    value: rowData[keyword],
  }
  if (otherOptions) {
    obj = {...obj, ...otherOptions}
  }
  if (otherOptions?.type === 'select') {
    obj = {...obj, value: rowData[keyword]?.[keyword + 'Name']}
  }
  // Also adapt to the requirement of overriding value key for selection options
  if (otherOptions?.valueJoinArray) {
    obj = {...obj, value: getJoinValueFromArray(rowData[keyword], otherOptions.valueJoinArray, rowData)}
  }
  return obj
}

export const getJoinValueFromArray = (data: any, array: any, rowData?: any) => {
  let value = ''
  array.map((item: any) => value += ((data?.[item] || rowData?.[item]) + ' / '))
  value = value.trim().replace(/\/$/, '')
  if (!value.replace(/\//g, '').replace(/undefined/g, '').trim().length) {
    value = ''
  }
  return value
}
export const padRightWithSpaces = (str:string, minLength:number) =>{
  if (str.length < minLength) {
    const spacesToAdd = minLength - str.length;
    const spaces = ' '.repeat(spacesToAdd);
    return str + spaces;
  }
  return str;
}
export const getItemsObj = (keyInfosArray: any, rowData: any) => {
  const obj: any = {}
  keyInfosArray.map((row: any) => {
    obj[row.key] = getItemObjFunction(rowData, row.label, row.key, row.otherOptions)
  })
  return obj
}

// Global validation function storage
const validationFunctionsMap = new Map<string, any>()

export const getColModelItem = (colInfo: any, keyInfosArray: any) => {
  // debugger
  // Store validation function for later use
  const validationFn = (rowData: any) => validateFn(rowData, getItemsObj(keyInfosArray(rowData), rowData), colInfo.keywords)

  // Store validation function globally
  if (validationFn && colInfo.field) {
    validationFunctionsMap.set(colInfo.field, validationFn)
  }

  return {
    title: colInfo.title,
    field: colInfo.field,
    cellStyle:colInfo.cellStyle,
    width:colInfo.width,
    sorting: false,
    // Disable automatic validation to allow save button
    validate: undefined,
    customFilterAndSearch: (inputValue: any, rowData: any) => filterFn(inputValue, getItemsObj(keyInfosArray(), rowData), colInfo.keywords),
    render: (rowData: any) => renderFn(getItemsObj(keyInfosArray(), rowData), colInfo.keywords),
    editComponent: (props: any) => editFn(props, getItemsObj(keyInfosArray(), props.rowData), colInfo.keywords),
  }
}

// Export function to get validation function
export const getValidationFunction = (field: string) => {
  return validationFunctionsMap.get(field)
}
export const  convertToNZTime=(utcTimestamp:any) => {
  const date = new Date(utcTimestamp);
  const nzDate = new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'Pacific/Auckland',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
  return nzDate;
}
// --------------------------------getRandomKey-------------------------------------
export const getRandomKey = (): string => Math.random().toString(36).substring(7)

// --------------------------------getDiffDaysByMomentJs-------------------------------------
export const getDiffDays = (comparedDate: any) => {
  const today = moment()
  return today.diff(moment(comparedDate + '.000Z'), 'days')
}

// --------------------------------getCurrentDateString(YYYY-MM-DD)-------------------------------------
export const getCurrentDateString = () => {
  const currentDate = new Date()
  return [currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate()].join('-')
}

// --------------------------------Chunk Array into groups-------------------------------------
export const chunkArr = (inputArray: any, perChunk: any) => {
  return inputArray.reduce((resultArray: any, item: any, index: any) => {
    const chunkIndex = Math.floor(index / perChunk)
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }
    resultArray[chunkIndex].push(item)
    return resultArray
  }, [])
}

// --------------------------------UTC To Local Date(Time) String-------------------------------------
export const toLocalDate = (utc: any) => {
  return utc && (new Date(utc + '.000Z')).toDateString()
}

export const toLocalDateTime = (utc: any) => utc && (new Date(utc + '.000Z')).toLocaleString()

// --------------------------------Add &nbsp; to Api string data (For table rowData presentation)-------------------------------------
export const nbsStr = (str: string, isNotCutting?: boolean,len?:number) => {
  if (!str) {
    return ''
  }
  const returnStr = str.toString().replace(/\s/g, '\u00a0').replace(/-/g, '\u2011').trim()
  const maxLength = len ? len : 60;
  const truncatedStr = returnStr.slice(0, maxLength);
  return returnStr.length > maxLength && !isNotCutting ? truncatedStr + '.' : returnStr;
}

// --------------------------------Replace space in string (For table filtering and searching)-------------------------------------
export const nsStr = (str: string) => {
  if (!str) {
    return ''
  }
  return str.toString().replace(/\s/g, '').trim()
}
export const toggleBlur = (flag:boolean) => {
  const rootChildren = document.querySelectorAll('#root *');

  if (!flag){
    for (let i = 0; i < rootChildren.length; i++) {
      if ('style' in rootChildren[i]) {
        (rootChildren[i] as HTMLElement).style.color = 'black';
        (rootChildren[i] as HTMLElement).style.textShadow = 'none';
      }
    }
  }
  else{
    for (let i = 0; i < rootChildren.length; i++) {
      if ('style' in rootChildren[i]) {
        (rootChildren[i] as HTMLElement).style.color = 'transparent';
        (rootChildren[i] as HTMLElement).style.textShadow = '0 0 8px #000';
      }
    }    
  }

}
// helpers.ts
export const convertNumericFields = (data: any, columns: any[]) => {
  const converted = { ...data }
  
  columns.forEach(col => {
    if (col.type === 'numeric' && col.field && converted[col.field] != null) {
      const value = converted[col.field]
      if (value !== '') {
        // 判断是否包含小数点，决定用 parseInt 还是 parseFloat
        const stringValue = value.toString()
        converted[col.field] = stringValue.includes('.') 
          ? parseFloat(value) 
          : parseInt(value, 10)
      }
    }
  })
  
  return converted
}

// --------------------------------Form Validation Helper-------------------------------------
/**
 * Handles form validation errors with proper error display
 * Usage: Wrap validateFields() calls with this function
 *
 * @example
 * try {
 *   const values = await formRef.validateFields()
 *   // process values
 * } catch (error) {
 *   handleFormValidationError(error)
 *   return
 * }
 */
export const handleFormValidationError = (error: any) => {
  import('./sweet-alert-service').then(({ default: SweetAlertService }) => {
    // Check if it's a validation error (has errorFields)
    if (error?.errorFields && error?.errorFields?.length > 0) {
      // Get the first error field
      const firstError = error.errorFields[0]
      const fieldName = Array.isArray(firstError.name) ? firstError.name.join(' -> ') : firstError.name
      const errorMessage = firstError.errors?.[0] || 'Invalid value'

      // Show lightweight warning message
      SweetAlertService.validationWarning(`${fieldName}: ${errorMessage}`)
    } else if (error?.message) {
      // Generic error
      SweetAlertService.validationWarning(error.message)
    } else {
      SweetAlertService.validationWarning('Please complete all required fields')
    }
  })
}